const initNumberCounter = () => {
  const numbers = document.querySelectorAll('.js-number');
  if (!numbers.length) return;

  numbers.forEach((el) => {
    // 最終値を保持（2回目以降も正しく動かすため）
    const raw = (el.textContent || '').trim().replace(/,/g, '');
    const targetValue = parseFloat(raw);
    if (Number.isNaN(targetValue)) return;

    const decimal = (raw.split('.')[1] || '').length;

    // 何回も入っても最終値が変わらないように data に保存
    el.dataset.target = String(targetValue);
    el.dataset.decimal = String(decimal);

    const run = () => {
      const target = parseFloat(el.dataset.target);
      const dec = parseInt(el.dataset.decimal, 10) || 0;
      const snapValue = dec ? Math.pow(10, -dec) : 1;

      // 進行中があれば止める
      gsap.killTweensOf(el);

      // 0 からスタート
      el.textContent = dec ? (0).toFixed(dec) : '0';

      gsap.to(el, {
        textContent: target,
        duration: 1.5,
        ease: 'power2.out',
        snap: { textContent: snapValue },
        onUpdate: () => {
          const v = parseFloat(el.textContent);
          el.textContent = dec ? v.toFixed(dec) : String(Math.round(v));
        },
      });
    };

    ScrollTrigger.create({
      trigger: el,
      start: 'top 80%',
      onEnter: run,
      onEnterBack: run,
      // markers: true,
    });
  });
};

const init = () => {
  initNumberCounter();
};

export default { init };
